import AbstractComponent from './AbstractComponent';

class DraggableScroll extends AbstractComponent {
  constructor() {
    super(...arguments);
  }

  bind() {
    super.bind();
    this.handleMouse = this.handleMouse.bind(this);
  }

  events(listen) {
    const listener = listen ? 'addEventListener' : 'removeEventListener';
    this.ui.$element[listener]('mousedown', this.handleMouse);
  }

  handleMouse(event) {
    switch (event.type) {
      case 'mousedown':
        this.downX = event.clientX;
        this.downScrollLeft = this.$element.scrollLeft;
        window.addEventListener('mousemove', this.handleMouse);
        window.addEventListener('mouseup', this.handleMouse);
        break;
      case 'mousemove':
        const moveX = event.clientX - this.downX;
        this.$element.scrollLeft = this.downScrollLeft - moveX;
        break;
      case 'mouseup':
        window.removeEventListener('mousemove', this.handleMouse);
        window.removeEventListener('mouseup', this.handleMouse);
        break;
    }
  }
}

export default DraggableScroll;
